import {
  makeStyles,
  Button,
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from '@fluentui/react-components';
import { FilterRegular } from '@fluentui/react-icons';
import React, { useState } from 'react';
import { iconButtonStyles } from '../../../app/common/styles/CommonStyleObjects';

interface IFilterCalloutProps {
  children: JSX.Element;
  triggerButtonId: string;
}

const useContentStyles = makeStyles({
  root: {
    boxSizing: 'border-box',
    padding: '30px',
    maxHeight: '100%',
    overflowY: 'auto',
  },
});

const FilterCallout = ({ children, triggerButtonId }: IFilterCalloutProps): JSX.Element => {
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);
  const styles = useContentStyles();

  return (
    <Popover
      open={isCalloutVisible}
      onOpenChange={(e, data) => setIsCalloutVisible(data.open)}
      positioning={{ autoSize: true, align: 'start' }}
      withArrow
      trapFocus
    >
      <PopoverTrigger disableButtonEnhancement>
        <Button
          appearance="subtle"
          id={triggerButtonId}
          icon={<FilterRegular color={iconButtonStyles.color} />}
          title="Filter"
          aria-label="Filter"
          aria-haspopup="dialog"
          aria-expanded={isCalloutVisible}
          onClick={() => setIsCalloutVisible(!isCalloutVisible)}
        />
      </PopoverTrigger>

      <PopoverSurface
        style={{
          padding: 0,
          overflow: 'visible',
        }}
      >
        <div className={styles.root}>{children}</div>
      </PopoverSurface>
    </Popover>
  );
};

export default FilterCallout;
